import { useEffect, useState } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import Marquee from "@/components/Marquee";
import ServicesSection from "@/components/ServicesSection";
import ManifestoSection from "@/components/ManifestoSection";
import WorkSection from "@/components/WorkSection";
import EstimateSection from "@/components/EstimateSection";
import Footer from "@/components/Footer";
import { ui } from "@/data/translations";
import { api, formatApiError } from "@/lib/api";

const description = {
  en: "Vincent General Construction Inc. delivers complete home improvements, stonework, plastering, drywall, paint and ceramic tile in Bensalem, PA and nearby communities.",
  es: "Vincent General Construction Inc. ofrece mejoras completas del hogar, piedra, enlucido, drywall, pintura y cerámica en Bensalem, PA y comunidades cercanas.",
};

export default function LandingPage() {
  const [content, setContent] = useState(null);
  const [language, setLanguage] = useState("en");
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/content").then(({ data }) => setContent(data)).catch((requestError) => setError(formatApiError(requestError)));
  }, []);

  useEffect(() => {
    document.title = language === "en" ? "Vincent General Construction Inc. | Bensalem, PA" : "Vincent General Construction Inc. | Construcción en Bensalem, PA";
    document.querySelector('meta[name="description"]')?.setAttribute("content", description[language]);
    document.documentElement.lang = language;
    if (content?.logo_url) {
      document.querySelector('meta[property="og:image"]')?.setAttribute("content", content.logo_url);
      document.querySelector('meta[property="og:image:alt"]')?.setAttribute("content", `${content.business_name} logo`);
      const schema = document.querySelector('script[type="application/ld+json"]');
      if (schema) {
        const structuredData = JSON.parse(schema.textContent);
        structuredData.image = content.logo_url;
        schema.textContent = JSON.stringify(structuredData);
      }
    }
  }, [language, content]);

  const navigateTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  if (error) return <div className="load-screen" data-testid="content-error"><p>{error}</p><a className="button button-accent" href="/">Reload</a></div>;
  if (!content) return <div className="load-screen" data-testid="content-loading"><div className="load-mark">VGC</div><p>Loading craft / Cargando oficio</p></div>;
  return <div className="site-shell" id="top"><Header content={content} language={language} setLanguage={setLanguage} /><main><HeroSection content={content} language={language} onNavigate={navigateTo} /><Marquee content={content} language={language} /><ServicesSection content={content} language={language} /><ManifestoSection content={content} language={language} /><WorkSection content={content} language={language} /><EstimateSection content={content} language={language} /></main><Footer content={content} language={language} /></div>;
}
